import PropTypes from "prop-types";
import React from "react";
import { createUseStyles } from "react-jss";
import _ from "lodash";
import {
  GR,
  GB,
  US,
  IT,
  CN,
  ES,
  FR,
  DE,
  NL,
  PT,
  IL,
  JP,
  TH,
  LT,
  ID,
  SA,
} from "country-flag-icons/react/1x1";
import jssVariables from "../../jss_setup";
import { InlineIcon } from "@iconify/react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

export function getFlag(input) {
  switch (input) {
    case "GR":
      return <GR />;
    case "EN-GB":
      return <GB />;
    case "EN-US":
      return <US />;
    case "IT":
      return <IT />;
    case "ZH":
      return <CN />;
    case "ES":
      return <ES />;
    case "FR":
      return <FR />;
    case "DE":
      return <DE />;
    case "NL":
      return <NL />;
    case "PT":
      return <PT />;
    case "HE":
      return <IL />;
    case "JA":
      return <JP />;
    case "TH":
      return <TH />;
    case "LT":
      return <LT />;
    case "AR":
      return <SA />;
    case "ID":
      return <ID />;
    default:
      return null;
  }
}

const styles = createUseStyles({
  link: (props) => ({
    fontSize: "large",
    alignItems: "center",
    cursor: "pointer",
    display: "grid",
    gridGap: `calc(${jssVariables.normal_gap} * 1.5)`,
    alignContent: "center",
    gridTemplateColumns: "max-content 1fr max-content",
    width: "100%",
    ..._.get(props, "customStyles.link", {}),
  }),
  icon: (props) => ({
    borderRadius: "50%",
    width: "2rem",
    height: "2rem",
    overflow: "hidden",
    border: "1px solid lightgray",
    ..._.get(props.customStyles, "icon", {}),
  }),
  label: (props) => ({
    fontWeight: 600,
    ..._.get(props.customStyles, "label", {}),
  }),
  tickIcon: (props) => ({
    color: jssVariables.colors.text.dark,
    fontSize: "x-large",
    justifySelf: "end",
    ..._.get(props.customStyles, "tickIcon", {}),
  }),
});
export const LanguageLink = ({
  customStyles,
  changelanguage,
  flagText,
  lang,
  label,
}) => {
  const classes = styles({
    customStyles,
  });

  const { i18n } = useTranslation();
  const selectedLanguage = i18n.language.toUpperCase();
  const withLangFlags = useSelector(
    (state) => state?.WebsiteMetadata?.metadata?.language_flags ?? true
  );

  return (
    <div className={classes.link} onClick={() => changelanguage(flagText)}>
      {withLangFlags ? (
        <div className={classes.icon}>{getFlag(flagText)}</div>
      ) : (
        <span>({lang})</span>
      )}
      <span className={classes.label}>{label}</span>
      {selectedLanguage === flagText ? (
        <InlineIcon icon="mdi:check" className={classes.tickIcon} />
      ) : null}
    </div>
  );
};
LanguageLink.defaultProps = {
  customStyles: {},
  flagText: "",
  label: "",
  lang: "EN",
};
LanguageLink.propTypes = {
  customStyles: PropTypes.object.isRequired,
  changelanguage: PropTypes.func.isRequired,
  flagText: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  lang: PropTypes.string.isRequired,
};

export const languageList = [
  { flagText: "GR", label: "Ελληνικά (GR)" },
  { flagText: "EN-US", label: "English (US)" },
  { flagText: "EN-GB", label: "English (UK)" },
  { flagText: "IT", label: "Italiano (IT)" },
  { flagText: "ZH", label: "中文 (ZH)" },
  { flagText: "ES", label: "Εspañol (ES)" },
  { flagText: "FR", label: "Français (FR)" },
  { flagText: "DE", label: "Deutsch (DE)" },
  { flagText: "NL", label: "Nederlands (NL)" },
  { flagText: "PT", label: "Português (PT)" },
  { flagText: "HE", label: "Hebrew (HE)" },
  { flagText: "JA", label: "日本語 (JA)" },
  { flagText: "TH", label: "ภาษาไทย (TH)" },
  { flagText: "LT", label: "Lietuvių (LT)" },
  { flagText: "ID", label: "Indonesian (ID)" },
  { flagText: "AR", label: "Arabic (AR)" },
];
